import { InterAreaConnection } from '@thive/fddm-types';

/**
 * @description Returns the connections that need a different smooth heading after a crab setting
 * change, already updated. Connections that already have the right smooth heading are left out.
 */
export const getConnectionsWithSmoothHeading = (
  connections: InterAreaConnection[],
  smoothHeading: boolean,
): InterAreaConnection[] =>
  connections.flatMap((connection): InterAreaConnection[] => {
    const isUpToDate = [...connection.aToBConnections, ...connection.bToAConnections].every(
      (c) => c.smoothHeading === smoothHeading,
    );
    if (isUpToDate) return [];

    return [
      {
        ...connection,
        aToBConnections: connection.aToBConnections.map((c) => ({ ...c, smoothHeading })),
        bToAConnections: connection.bToAConnections.map((c) => ({ ...c, smoothHeading })),
      },
    ];
  });
